import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import ToolTips from 'Components/ToolTips'
import { ConfigurationContext } from 'Root/ConfigurationProvider'
import WithWindowSize from 'Components/WithWindowSize'
import SvgIcon from 'Components/SvgIcon'
import Loadable from 'Components/LoadableToImported'

import MapboxLoader from 'Components/MapBox/MapboxLoader'

import { transitName } from '../../../../containers/layout/PhotosAndLocationModal/data'
import {
  _NearbyMapIntro,
  _MapOnlyViewCaption,
  _PlaceBaloons,
  _MobileBaloonsTitle,
  _PlaceInfo,
  _PlaceCount,
  _PlaceTitle,
  _NearbyCta,
  _NearbyCtaMobile,
  _NearbyCtaTable,
  _FloatingBaloons,
  _ExpandBtn,
  _PlaceInfoMobile,
  _DesktopPlaceTitle,
} from './styles'


export const IntroMap = Loadable({
  loader: () => import(/* wcomment: "IntroMap" */ './IntroMap'),
  loading: () => <div />,
  chunkName: 'IntroMap',
})


class NearbyMapIntro extends Component {
  // eslint-disable-next-line react/static-property-placement
  static contextType = ConfigurationContext

  constructor(props) {
    super(props)
    const { listing, building, schools } = props || {}
    const currentAddress = (listing && listing.address)
      || (building && building.primary_address)
      || (schools && schools.primary_address)
    this.state = {
      transitMarkers: null,
      currentAddress,
      selectedCategory: null,
      isMapboxReady: false,
    }
    this.computeNearbyStopsObj = this.computeNearbyStopsObj.bind(this)
    this.handleCategoryClick = this.handleCategoryClick.bind(this)
    this.setMapboxReady = this.setMapboxReady.bind(this)
  }

  static getDerivedStateFromProps(props, state) {
    const { listing, building, schools } = props || {}
    const currentAddress = (listing && listing.address)
      || (building && building.primary_address)
      || (schools && schools.primary_address)
    if(state.currentAddress !== currentAddress) {
      return {
        currentAddress,
      }
    }
  }

  componentDidMount() {
    this.computeNearbyStopsObj(this.props.nearbyStops)
  }

  componentDidUpdate(prevProps) {
    if(this.props.nearbyStops && prevProps.nearbyStops !== this.props.nearbyStops) {
      this.computeNearbyStopsObj(this.props.nearbyStops)
    }
  }

  handleCategoryClick(category) {
    this.setState({
      selectedCategory: category,
    })
    this.props.setSelectedCategory(category)
    this.props.googleAnalyticsEvent({
      category: 'nearby demographics map',
      action: `[${category} click]`,
    })
    this.props.handleDemographicMapClick()
  }

  computeNearbyStopsObj(nearbyStops) {
    if(nearbyStops) {
      const notEmptyNearbyStops = {}
      Object.keys(transitName).forEach((key) => {
        notEmptyNearbyStops[transitName[key]] = []
      })
      nearbyStops.forEach((item, index) => {
        notEmptyNearbyStops[transitName[item.type]]?.push({
          id: `${item.type}-${index}`,
          vehicleType: transitName[item.type],
          lat: item.latitude,
          lng: item.longitude,
          ...item,
        })
      })
      this.setState({ transitMarkers: notEmptyNearbyStops })
    }
  }

  setMapboxReady(isMapboxReady) {
    this.setState({ isMapboxReady })
  }

  render() {
    const {
      places, winWidth, desktopView,
      isMapOnlyView,
      listing, building,
      handleDemographicMapClick,
    } = this.props
    const { IS_CONDOS } = this.context
    const {
      currentAddress,
      transitMarkers,
    } = this.state
    const { lat, lng } = currentAddress || {}

    const groceryPlaces = places?.grocery?.data || {}
    const barRestoPlaces = places?.restaurant?.data || {}
    const schoolPlaces = places?.schools?.data || {}

    const groceryCount = groceryPlaces?.nbHits || 0
    const barRestoCount = barRestoPlaces?.nbHits || 0
    const schoolCount = schoolPlaces?.nbHits || 0
    const transitCount = places?.transit?.data?.nbHits || 0

    const title = listing?.title || building?.name
    const toolTipStyle = {
      width: 'fit-content',
      display: 'flex',
      alignItems: 'center',
      height: '44px',
      borderRadius: '10px',
      padding: '6px 13px',
      fontSize: '12px',
      lineHeight: '22px',
    }
    return (
      <Fragment>
        {
          !isMapOnlyView ?
            <_MobileBaloonsTitle>
              Within 1km {title ? `of ${title}` : ''}
            </_MobileBaloonsTitle>
            : ''
        }
        <_NearbyMapIntro
          desktopView={desktopView}
          isMapOnlyView={isMapOnlyView}
          onClick={
            isMapOnlyView ?
              handleDemographicMapClick
              : () => {
              }
          }
        >
          <_ExpandBtn onClick={handleDemographicMapClick}>
            <SvgIcon
              name="#icon-map-expand"
              width={24}
              height={24}
            />
          </_ExpandBtn>
          {
            lat && lng && (desktopView || isMapOnlyView) &&

            <>
              <MapboxLoader onLoad={() => this.setMapboxReady(true)} />
              {
                this.state.isMapboxReady &&
                  <IntroMap
                    currentAddress={currentAddress}
                    places={
                      (groceryPlaces.hits || barRestoPlaces.hits || schoolPlaces.hits) ?
                        [
                          ...groceryPlaces.hits,
                          ...barRestoPlaces.hits,
                          ...schoolPlaces.hits,
                        ]
                        : null
                    }
                    transitMarkers={transitMarkers}
                    selectedCategory={this.state.selectedCategory}
                    winWidth={winWidth}
                  />
              }
            </>
          }

          <_NearbyCtaMobile onClick={handleDemographicMapClick}>
            {
              isMapOnlyView ?
                'See what\'s nearby'
                : 'See what else is nearby'

            }
          </_NearbyCtaMobile>
          <_FloatingBaloons isSelected={this.state.selectedCategory}>
            <ToolTips
              overlay={'View all nearby transit stops'}
              placement={'top'}
              overlayInnerStyle={toolTipStyle}
            >
              <_PlaceInfo
                align="center"
                onClick={() => this.handleCategoryClick('transit')}
                isSelected={this.state.selectedCategory === 'transit'}
              >
                <SvgIcon
                  name="#icon-amenities-marker-transit-stops"
                  width={24}
                  height={24}
                />

                <_PlaceCount>{transitCount || 0}</_PlaceCount>
                <_DesktopPlaceTitle>&nbsp;Transit stops</_DesktopPlaceTitle>

              </_PlaceInfo>
            </ToolTips>
            <ToolTips
              overlay={'View all nearby schools'}
              placement={'top'}
              overlayInnerStyle={toolTipStyle}
            >
              <_PlaceInfo
                align="center"
                onClick={() => this.handleCategoryClick('schools')}
                isSelected={this.state.selectedCategory === 'schools'}
              >
                <SvgIcon
                  name="#icon-amenities-marker-school"
                  width={24}
                  height={24}
                />

                <_PlaceCount>{schoolCount}</_PlaceCount>
                <_DesktopPlaceTitle>&nbsp;Schools</_DesktopPlaceTitle>

              </_PlaceInfo>
            </ToolTips>
            <ToolTips
              overlay={'View all nearby grocery store'}
              placement={'top'}
              overlayInnerStyle={toolTipStyle}
            >
              <_PlaceInfo
                align="center"
                onClick={() => this.handleCategoryClick('grocery')}
                isSelected={this.state.selectedCategory === 'grocery'}
              >
                <SvgIcon
                  name="#icon-amenities-marker-grocery"
                  width={24}
                  height={24}
                />

                <_PlaceCount>{groceryCount}</_PlaceCount>
                <_DesktopPlaceTitle>&nbsp;Grocery stores</_DesktopPlaceTitle>

              </_PlaceInfo>
            </ToolTips>
            <ToolTips
              overlay={'View all nearby bars & restaurants'}
              placement={'top'}
              overlayInnerStyle={toolTipStyle}
            >
              <_PlaceInfo
                align="center"
                onClick={() => this.handleCategoryClick('restaurant')}
                isSelected={this.state.selectedCategory === 'restaurant'}
                restaurentMarker
              >
                <SvgIcon
                  name="#icon-amenities-marker-bars-restos"
                  width={22}
                  height={22}
                />
                <_PlaceCount>{barRestoCount}</_PlaceCount>
                <_DesktopPlaceTitle>&nbsp;Bars & Restaurants</_DesktopPlaceTitle>
              </_PlaceInfo>
            </ToolTips>
          </_FloatingBaloons>
        </_NearbyMapIntro>
        {
          !isMapOnlyView ?
            <_NearbyCtaTable>
              <_PlaceBaloons
                justify="around"
                align="center"
                desktopView={desktopView}
                isCondos={IS_CONDOS}
              >
                <_PlaceInfoMobile align="center">
                  <SvgIcon
                    name="#icon-amenities-baloon-transit-stops"
                    width={45}
                    height={45}
                  />
                  <div>
                    <_PlaceCount>{transitCount || 0}</_PlaceCount>
                    <_PlaceTitle>Transit stops</_PlaceTitle>
                  </div>
                </_PlaceInfoMobile>
                <_PlaceInfoMobile align="center">
                  <SvgIcon
                    name="#icon-amenities-baloon-school"
                    width={45}
                    height={45}
                  />
                  <div>
                    <_PlaceCount>{schoolCount}</_PlaceCount>
                    <_PlaceTitle>Schools</_PlaceTitle>
                  </div>
                </_PlaceInfoMobile>
                <_PlaceInfoMobile align="center">
                  <SvgIcon
                    name="#icon-amenities-baloon-grocery"
                    width={45}
                    height={45}
                  />
                  <div>
                    <_PlaceCount>{groceryCount}</_PlaceCount>
                    <_PlaceTitle>Grocery stores</_PlaceTitle>
                  </div>
                </_PlaceInfoMobile>
                <_PlaceInfoMobile align="center">
                  <SvgIcon
                    name="#icon-amenities-baloon-bars-restos"
                    width={45}
                    height={45}
                  />
                  <div>
                    <_PlaceCount>{barRestoCount}</_PlaceCount>
                    <_PlaceTitle>Bars & Restaurants</_PlaceTitle>
                  </div>
                </_PlaceInfoMobile>
              </_PlaceBaloons>
              <_NearbyCta onClick={handleDemographicMapClick} inBaloonTable>
                See what else is nearby
              </_NearbyCta>
            </_NearbyCtaTable>
            : ''
        }

        {
          isMapOnlyView ?
            <_MapOnlyViewCaption>
              View nearby schools, grocery stores, restaurants, bars and more!
            </_MapOnlyViewCaption>
            : ''
        }
      </Fragment>
    )
  }
}

NearbyMapIntro.propTypes = {
  building: PropTypes.shape({
    primary_address: PropTypes.shape({}),
    name: PropTypes.string,
  }),
  listing: PropTypes.shape({
    title: PropTypes.string,
  }),
  places: PropTypes.shape({
    grocery: PropTypes.shape({ data: PropTypes.shape({}) }),
    restaurant: PropTypes.shape({ data: PropTypes.shape({}) }),
    schools: PropTypes.shape({ data: PropTypes.shape({}) }),
    transit: PropTypes.shape({ data: PropTypes.shape({ nbHits: PropTypes.number }) }),
  }),
  nearbyStops: PropTypes.shape({}),
  winWidth: PropTypes.number,
  desktopView: PropTypes.bool,
  isMapOnlyView: PropTypes.bool,
  handleDemographicMapClick: PropTypes.func,
  setSelectedCategory: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
}
export default WithWindowSize(NearbyMapIntro)

